import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ApiService } from 'src/app/services/api.service';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  currentStep: 1 | 2 = 1;
  typeForm!: FormGroup;
  credentialsForm!: FormGroup;
  showSuccessPopup: boolean = false;
  currentYear: number = new Date().getFullYear();
  
  // Tracks session verification when continue is clicked
  isCheckingSession: boolean = false; 

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private apiService: ApiService,
    private cookie: CookieService,
    private commonService: CommonService
  ) {}

  ngOnInit(): void {
    // Set 'existing' as the default selected radio button
    this.typeForm = this.formBuilder.group({
      employeeType: ['existing', Validators.required]
    });

    this.credentialsForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  onContinue(): void {
    if (this.typeForm.valid) {
      const selectedType = this.typeForm.value.employeeType;
      
      if (selectedType === 'new_joinee') {
        const token = this.cookie.get('access_token');
        
        if (token) {
          this.isCheckingSession = true;
          // Verify if the token is still valid
          this.apiService.checkMe().subscribe({
            next: (res: any) => {
              this.isCheckingSession = false;
              this.commonService.initializeSession();
              // Route directly to LMS dashboard
              this.router.navigate(['/techsure/assessments']);
            },
            error: () => {
              // Token invalid/expired: clear it and send to OTP registration
              this.isCheckingSession = false;
              this.cookie.delete('access_token', '/');
              this.cookie.delete('refresh_token', '/');
              this.router.navigate(['/register']);
            }
          });
        } else {
          // No token exists, send straight to OTP registration
          this.router.navigate(['/register']);
        }
      } else if (selectedType === 'existing') {
        // Move to the old login screen
        this.currentStep = 2;
      }
    }
  }

  onLogin(): void {
    if (this.credentialsForm.valid) {
      const { username, password } = this.credentialsForm.value;
      
      const formData = new FormData();
      formData.append('username', username);
      formData.append('password', password);

      this.apiService.login(formData).subscribe({
        next: (res) => {
          this.cookie.set('access_token', res.access_token, { path: '/' });
          this.cookie.set('refresh_token', res.refresh_token, { path: '/' });
          this.commonService.initializeSession();
          this.router.navigate(['/vigi/product-queries']);
        },
        error: (err) => {
          this.showSuccessPopup = true;
        }
      });
    }
  }
}